import React, { useState } from 'react';

import { useAppMonitor } from '../../monitor';
import { regenerateActiveComponentFromSettings } from '../../store/actions/insertComponentDesignActions';
import { showNotOnMobileDialog } from '../../store/actions/popupActions';
import { ConfirmDialog } from '../dialogs/ConfirmDialog';
import { useAppDispatch, useIsClientInMobileMode } from '../hooks';

export function useConvertToSettingsLauncher() {
  const dispatch = useAppDispatch();
  const monitor = useAppMonitor();

  const mobile = useIsClientInMobileMode();

  const [dialogOpen, setDialogOpen] = useState(false);

  function launchConvertToSettings() {
    if (mobile) {
      dispatch(showNotOnMobileDialog('Converting to settings is not yet available on mobile.'));
    } else {
      setDialogOpen(true);
    }
  }

  function renderDialog() {
    return (
      dialogOpen && (
        <ConfirmDialog
          open
          title="Are you sure you want to go back to the original design settings?"
          message="Any additional loads or certain changes made since creating this component will be lost."
          onClose={(confirmed) => {
            setDialogOpen(false);

            if (confirmed) {
              dispatch(regenerateActiveComponentFromSettings());
              monitor.recordInteraction('Convert to Settings dialog opened');
            }
          }}
        />
      )
    );
  }

  return [renderDialog, launchConvertToSettings] as const;
}
